import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=18710e02&scoped=true&"
import script from "./js/countdown.js?vue&type=script&lang=js&"
export * from "./js/countdown.js?vue&type=script&lang=js&"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=18710e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18710e02",
  null
  
)

export default component.exports